import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';

@Component({ className: 'js-password-reveal' })
export class PasswordRevealComponent {
	private formField: HTMLElement;
	private input: HTMLInputElement;

	constructor(private element: HTMLElement) {
		this.formField = element.closest('.c-formfield') as HTMLElement;
		this.input = this.formField?.querySelector('input') as HTMLInputElement;

		if (this.input) {
			this.element.addEventListener('click', () => {
				if (this.input.type.toLowerCase() == 'password') {
					this.input.type = 'text';
					removeClass(this.element, 'icon-eye');
					addClass(this.element, 'icon-eye-off');
				} else {
					this.input.type = 'password';
					addClass(this.element, 'icon-eye');
					removeClass(this.element, 'icon-eye-off');
				}
			});
		}
	}
}
